export const categories = [
  {
    slug: 'hudong-party',
    name: '互动派对',
    description: '适合朋友聚会、团建活动的互动惩罚小游戏',
    icon: 'ri-team-line',
  },
  {
    slug: 'fun-punish',
    name: '趣味惩罚',
    description: '搞笑有趣的惩罚机制，让游戏充满欢笑',
    icon: 'ri-emotion-laugh-line',
  },
  {
    slug: 'mobile-fun',
    name: '手机趣味',
    description: '随时随地打开手机就能玩的趣味互动游戏',
    icon: 'ri-smartphone-line',
  },
  {
    slug: 'couple-games',
    name: '情侣互动',
    description: '增进情侣感情的趣味互动小游戏推荐',
    icon: 'ri-heart-line',
  },
  {
    slug: 'challenge-mode',
    name: '挑战模式',
    description: '充满竞技感的打屁股挑战游戏玩法',
    icon: 'ri-sword-line',
  },
  {
    slug: 'kids-fun',
    name: '亲子趣味',
    description: '适合亲子互动的温和趣味小游戏',
    icon: 'ri-parent-line',
  },
];

export const games = [
  {
    id: 1,
    title: '真心话大冒险打屁股版',
    slug: 'truth-or-dare-spank',
    category: 'hudong-party',
    image: 'https://readdy.ai/api/search-image?query=Fun%20party%20game%20scene%20with%20colorful%20game%20cards%20and%20cushions%20on%20a%20bright%20wooden%20floor%2C%20warm%20lighting%2C%20playful%20atmosphere%2C%20minimalist%20style%2C%20clean%20composition%2C%20soft%20shadows&width=800&height=600&seq=game-truth-dare&orientation=landscape',
    description: '经典真心话大冒险加入打屁股惩罚机制，让游戏更加刺激有趣！输家需要接受打屁股惩罚或选择真心话。',
    difficulty: '简单',
    players: '3-8人',
    time: '15-30分钟',
    rating: 4.8,
    featured: true,
  },
  {
    id: 2,
    title: '猜拳打屁股挑战',
    slug: 'rock-paper-scissors-spank',
    category: 'fun-punish',
    image: 'https://readdy.ai/api/search-image?query=Playful%20rock%20paper%20scissors%20game%20with%20colorful%20props%20on%20a%20bright%20table%2C%20warm%20atmosphere%2C%20clean%20minimalist%20style%2C%20soft%20natural%20lighting%2C%20fun%20and%20energetic%20composition&width=800&height=600&seq=game-rock-paper&orientation=landscape',
    description: '通过猜拳决胜负，输家接受打屁股惩罚，简单又刺激的经典玩法。',
    difficulty: '简单',
    players: '2人',
    time: '5-10分钟',
    rating: 4.6,
    featured: true,
  },
  {
    id: 3,
    title: '手机摇一摇打屁股',
    slug: 'shake-phone-spank',
    category: 'mobile-fun',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20with%20colorful%20game%20interface%20on%20screen%20on%20a%20bright%20desk%2C%20playful%20mobile%20game%20scene%2C%20warm%20lighting%2C%20clean%20minimalist%20composition%2C%20soft%20shadows&width=800&height=600&seq=game-shake-phone&orientation=landscape',
    description: '利用手机传感器摇一摇决定惩罚力度，趣味性十足的手机互动游戏。',
    difficulty: '简单',
    players: '2-4人',
    time: '10-20分钟',
    rating: 4.7,
    featured: true,
  },
  {
    id: 4,
    title: '情侣打屁股骰子游戏',
    slug: 'couple-dice-spank',
    category: 'couple-games',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20dice%20and%20romantic%20game%20props%20on%20a%20soft%20pink%20background%2C%20warm%20intimate%20atmosphere%2C%20clean%20minimalist%20style%2C%20gentle%20lighting%2C%20playful%20composition&width=800&height=600&seq=game-couple-dice&orientation=landscape',
    description: '掷骰子决定惩罚方式和力度，增进情侣感情的有趣互动游戏。',
    difficulty: '简单',
    players: '2人',
    time: '10-15分钟',
    rating: 4.9,
    featured: false,
  },
  {
    id: 5,
    title: '数字炸弹打屁股',
    slug: 'number-bomb-spank',
    category: 'hudong-party',
    image: 'https://readdy.ai/api/search-image?query=Exciting%20party%20game%20with%20number%20cards%20and%20colorful%20balloons%20on%20a%20bright%20wooden%20table%2C%20warm%20lighting%2C%20playful%20atmosphere%2C%20clean%20minimalist%20composition&width=800&height=600&seq=game-number-bomb&orientation=landscape',
    description: '猜数字范围逐渐缩小，猜中炸弹数字的人接受打屁股惩罚！',
    difficulty: '中等',
    players: '4-10人',
    time: '15-25分钟',
    rating: 4.5,
    featured: false,
  },
  {
    id: 6,
    title: '抢凳子打屁股版',
    slug: 'musical-chairs-spank',
    category: 'challenge-mode',
    image: 'https://readdy.ai/api/search-image?query=Energetic%20musical%20chairs%20game%20with%20colorful%20chairs%20in%20a%20bright%20room%2C%20warm%20lighting%2C%20playful%20party%20atmosphere%2C%20clean%20minimalist%20composition&width=800&height=600&seq=game-musical-chairs&orientation=landscape',
    description: '经典抢凳子游戏融入打屁股惩罚，最后没抢到凳子的人接受惩罚。',
    difficulty: '中等',
    players: '5-12人',
    time: '15-20分钟',
    rating: 4.4,
    featured: false,
  },
  {
    id: 7,
    title: '亲子拍拍乐游戏',
    slug: 'parent-child-pat-game',
    category: 'kids-fun',
    image: 'https://readdy.ai/api/search-image?query=Happy%20parent%20and%20child%20playing%20fun%20game%20with%20colorful%20soft%20toys%20on%20a%20bright%20carpet%2C%20warm%20lighting%2C%20gentle%20playful%20atmosphere%2C%20clean%20minimalist%20composition&width=800&height=600&seq=game-parent-child&orientation=landscape',
    description: '适合亲子互动的温和拍拍乐游戏，增进亲子关系，充满欢声笑语。',
    difficulty: '超简单',
    players: '2-3人',
    time: '10-15分钟',
    rating: 4.8,
    featured: false,
  },
  {
    id: 8,
    title: '扑克牌比大小惩罚',
    slug: 'card-compare-spank',
    category: 'fun-punish',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20playing%20cards%20spread%20on%20a%20bright%20wooden%20table%2C%20playful%20game%20scene%2C%20warm%20lighting%2C%20clean%20minimalist%20composition%2C%20soft%20shadows&width=800&height=600&seq=game-card-compare&orientation=landscape',
    description: '抽扑克牌比大小，点数小的人接受打屁股惩罚，简单刺激！',
    difficulty: '简单',
    players: '2-6人',
    time: '10-15分钟',
    rating: 4.3,
    featured: false,
  },
];